import React from 'react'
import image from '../Images/error.png'
import Navbar from './Navbar'

const Error = () => {
  return (
    <>
<Navbar/>
    <section className='Error'>
        <h1>404 ERROR </h1> 
        <img src={image}/>
    </section>
    </>
  )
}

export default Error